import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faImages, faStar, faHeart, faGem, faRocket } from '@fortawesome/free-solid-svg-icons';
import "./Hero.css";

function HeroSection() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoaded(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const scrollToContent = () => {
        const element = document.querySelector('.pokemon-binder');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="hero-section" style={{
            position: 'relative',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4))',
            overflow: 'hidden'
        }}>
            <div className="hero-background"></div>
            
            <div className="hero-floating-elements">
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
            </div>
            
            <div className="hero-content" style={{
                position: 'relative',
                zIndex: 3,
                maxWidth: '900px',
                padding: '0 30px',
                color: 'white'
            }}>
                <h1 className="hero-title" style={{
                    fontSize: '4.5rem',
                    fontWeight: 900,
                    color: '#ffffff',
                    textShadow: '0 8px 30px rgba(0, 0, 0, 0.7)',
                    marginBottom: '2rem',
                    background: 'linear-gradient(45deg, #ffffff, #f8f9fa, #ffffff)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    lineHeight: 1.1
                }}>
                    <FontAwesomeIcon icon={faGem} className="hero-title-icon" />
                    Premium Collectibles Universe
                </h1>
                <p className="hero-subtitle" style={{
                    fontSize: '1.4rem',
                    color: 'rgba(255, 255, 255, 0.95)',
                    marginBottom: '3rem',
                    fontWeight: 400,
                    textShadow: '0 4px 15px rgba(0, 0, 0, 0.5)',
                    lineHeight: 1.6
                }}>
                    Discover extraordinary treasures from vintage Star Wars memorabilia to rare Pokemon cards.
                    <br />Each piece tells a unique story of passion, craftsmanship, and timeless value.
                </p>
                
                <div className="hero-cta-container">
                    <button 
                        className="hero-cta"
                        onClick={scrollToContent}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '20px',
                            padding: '20px 45px',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '60px',
                            fontWeight: 700,
                            fontSize: '1.2rem',
                            boxShadow: '0 15px 40px rgba(102, 126, 234, 0.5)',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'translateY(-8px) scale(1.08)';
                            e.target.style.boxShadow = '0 25px 60px rgba(102, 126, 234, 0.7)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'translateY(0) scale(1)';
                            e.target.style.boxShadow = '0 15px 40px rgba(102, 126, 234, 0.5)';
                        }}
                    >
                        <FontAwesomeIcon icon={faRocket} />
                        Explore Collection
                        <FontAwesomeIcon icon={faArrowDown} />
                    </button>
                </div>
                
                <div className="hero-stats">
                    <div className="hero-stat">
                        <FontAwesomeIcon icon={faStar} />
                        <span className="hero-stat-number">500+</span>
                        <span className="hero-stat-label">Premium Items</span>
                    </div>
                    <div className="hero-stat">
                        <FontAwesomeIcon icon={faImages} />
                        <span className="hero-stat-number">5</span>
                        <span className="hero-stat-label">Collections</span>
                    </div>
                    <div className="hero-stat">
                        <FontAwesomeIcon icon={faHeart} />
                        <span className="hero-stat-number">20+</span>
                        <span className="hero-stat-label">Years Collecting</span>
                    </div>
                </div>
            </div>
            
            <div className="hero-scroll-indicator" onClick={scrollToContent}>
                <FontAwesomeIcon icon={faArrowDown} />
            </div>
        </div>
    );
}

export default HeroSection;